import { setDifference, jsonCopyObject, setUnion, getSet, createId, unknownDateToDate } from 'globals/helpers/helpers';
import { WFWorker, WorkforceGroup, JoiEvent, eventsFeature } from './../store/events.era';
import { getFilteredTasksByType } from '../store/reselectors/filteredTasks.reselector';
import { Subtask, DBTaskPropertyWhiteList, TaskTriggers, getTaskTriggers, tasksFeature, tasksActions } from './../store/tasks.era';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../src/environments/environment';
import { LogService } from './log.service';
import { EventService } from "./event.service";
import { lastValueFrom, Subject } from 'rxjs';
import { ErrorStreamChange } from "../models/$error.model";
import { EventStreamChange } from "../models/$event.model";
import { Injectable } from "@angular/core";
import { UserService } from "../services/user.service"
import { Task } from 'src/app/store/tasks.era';
import { tap, takeUntil, first, take } from 'rxjs/operators';
// import { NotificationsService } from './notifications.service';
import { Store, createSelector, select } from '@ngrx/store';
import { EventPreferenceDoc, eventPreferenceFeature, EventPreferenceState } from 'src/app/store/event.preferences.era'
import { workforceFeature, WorkforceState } from '../store/workforce.era';
import { getUserWorkforceGroups } from '../store/reselectors/workforce.reselector';
import { tasksReadyReselector  } from '../store/reselectors/tasks.reselector';
import { OnReset, Transitions } from './transition.service.helpers';
import { checkTriggers } from 'src/app/store/reselectors/tasks.reselector';
import { JoiNotification } from 'globals/store/notifications.model';
import { MatDialog } from '@angular/material/dialog';
import { openDialogGetResult } from '../helpers/angular-helpers';
import { ManageTaskReturnType, ManageTaskData } from '../modules/manage/manage-task-data';
import { OMEGA_GROUP_ID, TaskStatus } from 'globals/store/tasks.data';
import { Dictionary } from '@ngrx/entity';
import { cleanEntry, sleepForMS, subTilDestroy } from '../helpers/helpers';
import { EventPermissionsService } from 'src/app/services/event.permissions.service';
import { TASK_SAVE_DEBOUNCE_AND_SKIP_DUPLICATE_MS } from '../helpers/constants';
import { activeAccountIdsReselector } from '../store/reselectors/accounts.reselector';
import { AccountsService } from './accounts.service';
import { getOneStorePromise } from '../store/ui.era';
import { permissionsActions } from '../store/permissions.era';
import { collection, collectionChanges, deleteDoc, doc, DocumentChange, Firestore, query, setDoc, updateDoc, where } from '@angular/fire/firestore';
import { NotificationsService } from './notifications.service';

@Injectable({ providedIn: 'root' })
export class TaskService implements OnReset {

  readonly _file: string = 'task.service.ts';
  readonly api = `${environment.functionsURL}api/app`;
  public was_focused: string;
  public forWorker: any = {};
  private _yourGroupsSet: Set<string>
  
  public $taskDestroy: Subject<EventStreamChange | boolean> = new Subject()

  private workersByUId: { [key: string]: WFWorker } = {}
  private workersByEmail: { [key: string]: WFWorker } = {}
  private workforceGroupsById: { [key: string]: WorkforceGroup } = {}
  private allWorkersByUId: { [key: string]: WFWorker } = {}
  private allWorkersByEmail: { [key: string]: WFWorker } = {}
  private allWorkforceGroupsById: { [key: string]: WorkforceGroup } = {}
  
  public currentEvent: JoiEvent
  public events: Dictionary<JoiEvent>
  public $destroy: Subject<boolean> = new Subject()
  private fetchedEventIds: Set<string> = new Set()
  private taskUpdateTimes: { [taskId: string]: number } = {}
  private subscriptionIdsByTaskId: { [taskId: string]: Set<string> } = {}
  public storeTasks: Dictionary<Task>

  onReset(resetType, value = null) {
    if (resetType === Transitions.OnExitUser || resetType === Transitions.OnExitEvent) {
      this.reset()
    }
  }

  reset() {
    this.$taskDestroy.next(false)
    this.fetchedEventIds = new Set()
    this._yourGroupsSet = null
    this.subscriptionIdsByTaskId = {}
  }

  constructor(
    private accountsService: AccountsService,
    private db: Firestore,
    private notifications: NotificationsService,
    private eventService: EventService,
    private userService: UserService,
    private log: LogService,
    private http: HttpClient,
    //private notifications: NotificationsService,
    public store: Store,
    private eventPermissionsService: EventPermissionsService
  ) {
    this.store.select(workforceFeature.selectWorkforceState).subscribe(({ workersByUId, workersByEmail, workforceGroupsById, allWorkersByEmail, allWorkforceGroupsById, allWorkersByUId }: WorkforceState) => {
      this.workersByUId = workersByUId
      this.workersByEmail = workersByEmail
      this.workforceGroupsById = workforceGroupsById
      this.allWorkersByEmail = allWorkersByEmail
      this.allWorkersByUId = allWorkersByUId
      this.allWorkforceGroupsById = allWorkforceGroupsById
    })

    subTilDestroy(this, select(eventsFeature.selectEvent), 'currentEvent')
    subTilDestroy(this, select(eventsFeature.selectEntities), 'events')
    subTilDestroy(this, select(tasksFeature.selectEntities), 'storeTasks')

    this.store.select(tasksReadyReselector).subscribe(({ myGroupsSet, permissions }) => {
      // console.log('myGroupsSet ', myGroupsSet);
      // console.log('permissions ', permissions);
      if (!myGroupsSet || !permissions || permissions.length === 0) return
      if (!this._yourGroupsSet || (this._yourGroupsSet && setDifference(myGroupsSet, this._yourGroupsSet).size)) {
        this.reset()
        this._yourGroupsSet = myGroupsSet // tu casa es mi casa
        this.getTasks(eventService.eventId, this._yourGroupsSet, permissions)
      }
    })

    this.store.pipe(select(tasksFeature.selectFocused)).subscribe((focused) => {
      if (this.was_focused && !focused && this.was_focused !== 'new') {
        this.store.pipe(select(tasksFeature.selectEntities), take(1)).subscribe(tasks => {
          this.notifyResponsible(tasks[this.was_focused])
        })
      }
      if (focused) this.was_focused = focused;
    })
  }

  async getTasksByEvents(workforceEvents: JoiEvent[]) {

    const activeAccountIds = await lastValueFrom(this.store.select(activeAccountIdsReselector).pipe(take(1))) 
    const viewableEvents = workforceEvents.filter(e => !e.closed && activeAccountIds.has(e?.accountId))

    const eventIds = getSet(viewableEvents, 'eventId')
    const missingIds = setDifference(eventIds, this.fetchedEventIds)
    this.fetchedEventIds = setUnion(eventIds, this.fetchedEventIds)
    // console.log({ viewableEvents, activeAccountIds, workforceEvents, eventIds, missingIds, nMissing: missingIds.size })
    while (!this.userService.email) {
      console.log("Fetching user...")
      await sleepForMS(50)
    }
    if (!missingIds.size) return

    missingIds.forEach(async (eventId) => {
      // console.log("Starting to get permissions for tasks for " + eventId)
      const event = viewableEvents.find(e => e.eventId === eventId)
      const groups = getUserWorkforceGroups(event.wf_groups, this.userService.email)
      const permissions = await this.eventPermissionsService.getRestrictionsFor(this.userService.uid, eventId)
      this.store.dispatch(permissionsActions.loadEventPermissions( eventId, permissions.types ))
      this.getTasks(eventId, groups, permissions.types)
    })
  }

  async getTasks(eventId, groups: Set<string>, permissions: string[]) {

    const taskSubs: { id: string, sub }[] = []
    if (!eventId) console.log('eventId IS MISSING IN THE DB CALL ', eventId);
    if (permissions.includes('program') || permissions.includes('logistics') || permissions.includes('supervisor')) {
      taskSubs.push({ id: createId(), sub: query(collection(this.db, 'tasks'), where('eventId', '==', eventId), where('groupVisibility', 'array-contains', '--all--')) })
      // console.log('showing all too')
    }
    groups.forEach(group => {
      taskSubs.push({ id: createId(), sub: query(collection(this.db, 'tasks'), where('eventId', '==', eventId), where('groupVisibility', 'array-contains', group)) })
    });
    taskSubs.push({ id: createId(), sub: query(collection(this.db, 'tasks'), where('eventId', '==', eventId), where('visibility', 'array-contains', this.userService.email)) })
    if (!this.forWorker[eventId]) {
      // this.forWorker[eventId] = Object['assign']({}, this.userService.user);
    }
    if (taskSubs.length) this.store.dispatch(tasksActions.increaseLoadingCount(taskSubs.length))

    // potential memory leak here
    const endSubject = new Subject()
    this.$taskDestroy.subscribe(o => {
      endSubject.next(true)
      endSubject.complete()
    })
    this.store.pipe(select(eventsFeature.selectEntities), takeUntil(this.$taskDestroy)).subscribe(events => {
      const event = events[eventId]
      if (!event) {
        endSubject.next(true)
        endSubject.complete()
      }
    })
    
    taskSubs.forEach(({ id, sub: stream }) => {
      collectionChanges(stream).pipe(
        takeUntil(endSubject),
      ).subscribe({next: (changes: DocumentChange<Task>[]) => this.handleTaskChangesFromDB(changes, eventId, id),
      error: async(response) => {
        const event = this.events[eventId]
        if (!event) console.log("CAN'T GET RID OF THIS BUG, SORRY TONY. I TRIED IN SEVERAL WAYS.  IT DOESN'T AFFECT HOW THE APP WORKS")
        else this.log.error({ file: this._file, function: 'getTasks', response, error: new Error() })
      }})
    })
  }

  initializeTaskFromChangeAction(changeAction: DocumentChange<Task>, eventId: string): Task {
    const task: Task = changeAction.doc.data()
    const isCurrentEvent = this.currentEvent && this.currentEvent.eventId === eventId
    const event = isCurrentEvent ? this.currentEvent : this.events[eventId]
    if (!event) {
      // events are loaded first so this should never happen
      console.log("MISSING EVENT FOR TASK", { task, eventId, events: this.events, currentEvent: this.currentEvent })
      return
    }

    task.accountId = event?.accountId

    
    if ( task.flag && task.flag !== true ) {
      task.flag = false;
    }

    task.id = changeAction.doc.id // cheaply ensure that the id and DB id are always in sync
    if (task.program === "''") task.program = null // the "None" value in the old task dialog was setting program as two single quotes, '', instead of an empty value (NOT an empty string)
    if (!task.groupVisibility) {
      console.log("TASK MISSING groupVisibility, SETTING TO DEFAULT VALUE", { unmodifiedTask: jsonCopyObject(task) })
      task.groupVisibility = [OMEGA_GROUP_ID]
    }

    // console.log(task.name + " BEFORE: ", jsonCopyObject(task))
    
    const groupsById = (isCurrentEvent ? this.workforceGroupsById : this.allWorkforceGroupsById) || {}
    const workersByEmail = (isCurrentEvent ? this.workersByEmail : this.allWorkersByEmail[eventId]) || {}
    const workersById = (isCurrentEvent ? this.workersByUId : this.allWorkersByUId[eventId]) || {}

    // since a single event / events are loaded first this should work correctly
    task.visibility = task.visibility.filter(email => workersByEmail[email])
    task.groupVisibility = task.groupVisibility.filter(g => g === OMEGA_GROUP_ID || groupsById[g])
    task.responsibility = workersByEmail[task.responsibility] ? task.responsibility : null
    task.createdBy = workersById[task.createdBy] ? task.createdBy : null // maybe don't null out creator even if not on workforce

    // console.log(task.name + " AFTER: ", jsonCopyObject(task))

    if (task.dueDate) {
      task.date = unknownDateToDate(task.dueDate)
      if (!task.completed && task.date < new Date()) {
        task.isOverDue = true
      }
    }

    if (!task.status) task.status = task.completed ? 'complete' : 'open'

    return task
  }

  handleTaskChangesFromDB(changes: DocumentChange<Task>[], eventId: string, subscriptionId: string) {
    this.store.dispatch(tasksActions.decreaseLoadingCount())
    // I'm taking out the store subscription here that updates the loading status.  This is NOT the place to put that if we need it, as this handles a TON of changes from the database.
    const now = (new Date()).getTime()
    changes = changes.filter(c => {
      const id = c.doc.id
      if (c.type === 'added') {
        if (!this.subscriptionIdsByTaskId[id]) this.subscriptionIdsByTaskId[id] = new Set()
        this.subscriptionIdsByTaskId[id].add(subscriptionId)
      } else if (c.type === 'removed') {
        this.subscriptionIdsByTaskId[id].delete(subscriptionId)
        if (!this.subscriptionIdsByTaskId[id].size) return true // when no subs left allow deletions
      }      
      
      const lastLoaded = this.taskUpdateTimes[id]
      if (lastLoaded) {
        const timeBetween = now - lastLoaded
        if (timeBetween < TASK_SAVE_DEBOUNCE_AND_SKIP_DUPLICATE_MS) {
          // console.log(`Skipping loading of ${id} since only ${Math.round(timeBetween)}ms have passed since last load`)
          return false
        }
      }
      this.taskUpdateTimes[id] = now
      return true
    })
    if (!changes.length) return

    const tasksToAdd: Task[] = changes.filter(c => c.type === 'added').map(c => this.initializeTaskFromChangeAction(c, eventId)).filter(t => t) // sometimes tasks don't initialize properly.  For example when an event is moved to a new account
    if (tasksToAdd.length) this.store.dispatch(tasksActions.addManyTasks(tasksToAdd))

    changes.filter(c => c.type !== 'added').forEach(change => {
      switch (change.type) {
        case 'modified':
          const modifiedTask = this.initializeTaskFromChangeAction(change, eventId)
          if (!modifiedTask) return // sometimes tasks don't initialize properly.  For example when an event is moved to a new account
          const id = modifiedTask.id
          this.notifyResponsible(modifiedTask)
          // console.log(`Task id: ${id}`, modifiedTask)
          this.store.dispatch(tasksActions.modifiedFromDB(id, modifiedTask))
          break
        case 'removed':
          const removedId = change.doc.id
          if (!this.subscriptionIdsByTaskId[removedId].size) {
            const pre_removed_task = this.storeTasks[change.doc.id]
            if (pre_removed_task) this.notifyResponsible(pre_removed_task)
            this.store.dispatch(tasksActions.removedFromDB(change.doc.id))
          }
          break
      }
    })
  }
  
  async updateStatus(task: Task, status: TaskStatus) {
    if ((task.status !== 'complete' && status === 'complete') || (task.status === 'complete' && status !== 'complete')) {
      this.updateComplete(task, status) 
    } else this.updateTask(task.id, { status })
  }

  getToggleSubtaskCompleteData(task: Task, subtask: Subtask) {
    // need to extract so it doesn't immediately save in manage task
    let subtasksCompleted: number = task.subtasks.filter(subtaskId => task.subtasks_obj[subtaskId].completed).length
    const update_subtask = { ...subtask }
    update_subtask.completed = !update_subtask.completed
    update_subtask.completedBy = update_subtask.completed ? this.userService.email : ''
    update_subtask.completedAt = update_subtask.completed ? new Date() : null
    if (update_subtask.completed) subtasksCompleted++
    else subtasksCompleted--;
    if (subtasksCompleted < 0) subtasksCompleted = 0;
    if (subtasksCompleted > task.subtasks.length) subtasksCompleted = task.subtasks.length
    return { update_subtask, subtasksCompleted }
  }

  updateSubtaskCompleted(task: Task, subtask: Subtask) {
    const { update_subtask, subtasksCompleted } = this.getToggleSubtaskCompleteData(task, subtask)
    const update_obj: Partial<Task> = {
      ['subtasks_obj.' + subtask.id]: update_subtask,
      subtasksCompleted
    }
    this.updateTask(task.id, update_obj, { file: this._file, function: 'updateComplete' })
  }

  updateComplete(task: Task, status: TaskStatus) { // used when a task's checkbox is ticked
    console.log("UPDATE COMPLETE BEING CALLED, NEW STATUS: " + status)
    const update_obj: Partial<Task> =  {
      completed: task.completed,
      completedBy: task.completed ? this.userService.email : '',
      completedAt: task.completed ? new Date() : null,
      status
    }
    const trigger: TaskTriggers = getTaskTriggers()
    trigger.task_status_has_changed = true;
    this.store.dispatch(tasksActions.addTriggers( task.id, trigger ))
    this.updateTask(task.id, update_obj, { file: this._file, function: 'updateComplete' })
  }

  setCompletedTotal(task: Task) {
    setTimeout(_ => {
      task.subtasksCompleted = task.subtasks.filter(subtaskId => task.subtasks_obj[subtaskId].completed).length;
    })
  }

  updateFlag(task) {
    return this.updateTask(task.id, { flag: !task.flag })
  }

  async createOrUpdateEventPreferencesWithSingleTask(taskId: string): Promise<void> {
    let eventPreferencesState: EventPreferenceState
    let count = 0;
    let limit = 20;
    while (count < limit) {
      eventPreferencesState = await getOneStorePromise(this.store, select(eventPreferenceFeature.selectEventPreferencesState))
      console.log(`Event preferences still loading: ${eventPreferencesState.loading}`, eventPreferencesState)
      if (!eventPreferencesState.loading) break
      await sleepForMS(50)
      count++
    }
    const preferences = jsonCopyObject(eventPreferencesState.document)
    if (!preferences ||!preferences.createdAt) {
      const document: EventPreferenceDoc = {
        createdAt: new Date(),
        task_order: [taskId]
      }
      await this.eventService.createEventPreferences(document, this.eventService.eventId, this.userService.uid, { file: this._file, function: 'addTask', error: new Error })
    } else {
      preferences.task_order.push(taskId)
      await this.eventService.updateEventPreferences(preferences, this.eventService.eventId, this.userService.uid, { file: this._file, function: 'addTask', error: new Error })
    }
  }

  async saveNewTask(task: Partial<Task> | Task, log_data: Partial<ErrorStreamChange> = {}): Promise<Task> { // CANNOT BE USED TO UPDATE TASKS ANY MORE.
    task.id = this.createId()
    await this.createOrUpdateEventPreferencesWithSingleTask(task.id)

    const triggers: { [taskId:string]: TaskTriggers } = await getOneStorePromise(this.store, select(tasksFeature.selectTriggers))
    if (triggers.new) {
      this.store.dispatch(tasksActions.addTriggers(task.id, triggers.new))
      this.store.dispatch(tasksActions.clearTriggers('new'))
    }
    const catchHandler = response => {
      this.log.error({
        response,
        data: { task },
        error: new Error,
        message: 'There was an error adding the task',
        ...log_data
      })
    }
    task.createdAt = new Date()
    const created_task = cleanEntry(task, DBTaskPropertyWhiteList) as Task
    console.log({ created_task })
    const ref = doc(this.db, `tasks/${task.id}`)
    await setDoc(ref, created_task, { merge: true }).then(() => {
      this.notifyResponsible(created_task)
    }).catch(catchHandler)

    return created_task
  }

  createAndSaveTask(name = '', eventId: string = null, dueDate: string = null, entityId: string = null, content: string = null): Promise<Task> {
    const task: Task = {
      name,
      files: [],
      groupVisibility: ["--all--"],
      visibility: [this.userService.email],
      seen: { [this.userService.uid]: true },
      createdBy: this.userService.uid,
      comments: [],
      commentBookmarks: {},
      eventId: eventId || this.eventService.eventId,
      id: 'new',
      content
    } as Task
    if (dueDate) task.dueDate = dueDate
    if (entityId) task.entityId = entityId
    
    return this.saveNewTask(task)
  }





  getUpdatedAsReadCommentBookmarksOrNull(task: Task) {
    // need to extract so it doesn't immediately save in manage task
    let { comments, commentBookmarks } = task
    if (comments && comments.length && (!commentBookmarks || !commentBookmarks[this.userService.uid] || commentBookmarks[this.userService.uid] !== comments.length)) { // WHEW!
      console.log("Marking unread comments...")
      if (!commentBookmarks) {
        commentBookmarks = {}
      }
      commentBookmarks[this.userService.uid] = comments.length
      return commentBookmarks
    }
    return null
  }

  markUnreadComments(task: Task) {
    const commentBookmarks = this.getUpdatedAsReadCommentBookmarksOrNull(task)
    if (!commentBookmarks) return
    this.updateTask(task.id, { commentBookmarks })
  }

  updateFullTask(task: Task) {
    this.updateTask(task.id, task)
  }

  toggleTaskSeen(task: Task) {
    if (!task.seen) task.seen = {}
    if (task.seen[this.userService.uid]) {
      task.seen[this.userService.uid] = false
    } else {
      task.seen[this.userService.uid] = true
    }
    this.updateTask(task.id, { seen: task.seen }, { function: 'toggleTaskSeen', error: new Error })
  }

  toggleTaskFlagged(task: Task) {
    this.updateTask(task.id, { flag: !task.flag })
  }

  toggleTaskCompleted(task: Task) {
    if (!task.completed) this.markSingleTaskCompleted(task)
    else this.markSingleTaskIncompleted(task)
  }

  markSingleTaskCompleted(task: Task) {
    task.completed = true
    task.completedBy = this.userService.email
    task.completedAt = new Date()
    this.triggerTaskStatusHasChangedAndSave(task)
  }

  markSingleTaskIncompleted(task: Task) {
    task.completed = false
    task.completedBy = null
    task.completedAt = null
    this.triggerTaskStatusHasChangedAndSave(task)
  }

  triggerTaskStatusHasChangedAndSave(task: Task) {
    const trigger:TaskTriggers = getTaskTriggers();
    trigger.task_status_has_changed = true;
    this.store.dispatch(tasksActions.addTriggers(task.id, trigger))
    this.updateTask(task.id, task)
  }


  updateTask(taskId: string, task: Partial<Task>, log_data: Partial<ErrorStreamChange> = {}) {
    const ref = doc(this.db, `tasks/${taskId}`);
    // console.log("Calling update task", { task: jsonCopyObject(task)})
    // need to save notif stuff to store
    const updated_task = cleanEntry(task, DBTaskPropertyWhiteList)
    // console.log({ updated_task: jsonCopyObject(updated_task) })
    return updateDoc(ref, updated_task).catch(response => {
      this.log.error({
        response,
        data: { task },
        error: new Error,
        message: 'There was an error updating the task',
        ...log_data
      });
    })
  }

  async makeAndSaveAndOpenWorkerTask(worker: WFWorker, dialog: MatDialog, manageTaskComponent: any) { // the component must be passed in (and UNTYPED) to avoid a circular dependency
    const { email, uid } = this.userService
    const newTask = {
      name: '',
      files: [],
      groupVisibility: ["--all--"],
      visibility: [this.userService.email],
      seen: { [this.userService.uid]: true },
      createdBy: uid,
      eventId: this.eventService.eventId,
      id: 'new',
      responsibility: worker.email,
    } as Task
    if (email !== worker.email) newTask.visibility.push(worker.email)
    const task = await this.saveNewTask(newTask)

    this.store.dispatch(tasksActions.taskInFocus(task.id ))
    const data: ManageTaskData = {
      task,
      readOnly: false,
      createdForWorker: true,
    }
    this.store.dispatch(tasksActions.taskInFocus(task.id))


    await openDialogGetResult<ManageTaskReturnType>(dialog, manageTaskComponent, { autoFocus: true, disableClose: true, data, panelClass: 'full-screen-modal' })
    this.store.dispatch(tasksActions.taskInFocus(null))
  }



  updateRemindTime(taskId) {
    const url = `${this.api}/update-remind-time`;
    this.http.post(url, { taskId })
  }

  createId() {
    return createId();
  }

  notifyResponsible(task: Task) {
    if (!task) return;
    this.store.pipe(select(checkTriggers), take(1)).subscribe(({ all_triggers, focused }) => {
      const triggers = all_triggers[task.id];
      if (!triggers || focused) return;
      this.checkTriggersAndTaskToSendNotifications(task, triggers)
      this.store.dispatch( tasksActions.clearTriggers(task.id));
    })
  }

  checkTriggersAndTaskToSendNotifications(task: Task, triggers: TaskTriggers) {
    if (triggers.task_status_has_changed) {
      const task_creator = this.workersByUId[task.createdBy];
      const responsible = this.workersByEmail[task.responsibility];
      const status_changed_to = 'status_to_' + (task.status === 'complete' ? "completed" : "incomplete");
      if (task_creator && this.userService.email !== task_creator.email) this.sendTaskNotification(task, { permissions: 'task_inform_creator', subtype: status_changed_to }, task_creator.email);
      if (responsible && responsible.email !== this.userService.email && responsible.status !== 'notInvited') {
        this.sendTaskNotification(task, { permissions: 'task_responsible', subtype: status_changed_to }, task.responsibility);
      }
    }
    if (!task.completed) {
      if (triggers.was_responsible_on_delete) this.sendTaskNotification(task, { permissions: 'task_responsible', subtype: 'delete' }, triggers.was_responsible_on_delete)
      if (triggers.inform_creator_on_delete) this.sendTaskNotification(task, { permissions: 'task_inform_creator', subtype: 'delete' }, triggers.inform_creator_on_delete)
      if (triggers.will_be_responsible) this.sendTaskNotification(task, { permissions: 'task_responsible', subtype: 'added' }, triggers.will_be_responsible)
      if (triggers.wont_be_responsible) this.sendTaskNotification(task, { permissions: 'task_responsible', subtype: 'remove' }, triggers.wont_be_responsible)
      if (triggers.should_update_remindTime) this.updateRemindTime(task.id)
    }
  }

  sendTaskNotification(task: Task, notification: Partial<JoiNotification>, recipient_email?: string) {
    console.log('sendTaskNotification ', notification, recipient_email);
    if (!notification.type) notification.type = 'task';
    if (!notification.task_name) notification.task_name = task.name;
    if (!notification.taskId) notification.taskId = task.id;
    if (notification.recipients) {
      const uid_idx = notification.recipients.indexOf(this.userService.uid);
      if (uid_idx > -1) notification.recipients.splice(uid_idx, 1);
    }
    if (recipient_email) {
      const recipient = this.workersByEmail[recipient_email];
      if (recipient && recipient.uid && recipient.uid !== this.userService.uid && recipient.status !== 'notInvited') {
        notification.recipients = [recipient.uid]
      }
    }
    console.log('notification ', notification);
    this.notifications.makeNotification(notification, this.currentEvent);
  }


  viewByWorker(worker) {
    const eventId = this.eventService.eventId;
    this.forWorker[eventId] = worker;
    // this.completedTasks[eventId] = this.returnTotal(this.tasks[eventId], this.forWorker[eventId], true);
  }


  deleteTask(task: Task, log_data: any = {}) {
    const ref = doc(this.db, `tasks/${task.id}`);
    return deleteDoc(ref).catch(response => {
      this.log.error({
        response,
        data: { task },
        error: new Error,
        message: 'There was an error deleting the task',
        ...log_data
      });
    })
  }

  markAllFilteredAsSeen(filterPage: string) {
    // only marks tasks as seen that are currently viewable / filtered in the place this is coming from

    this.store.pipe(select(getFilteredTasksByType[filterPage])).pipe(first()).subscribe((tasks: Task[]) => {
      const batch = [];
      tasks.filter(t => !t.seen || !t.seen[this.userService.uid]).forEach((task: Task) => {
        if (!task.seen) task.seen = {};
        task.seen[this.userService.uid] = true;
        batch.push(task.id);
      })
      if (batch.length > 0) {
        const url = `${this.api}/batch-update-task-seen`;
        this.http.post(url, { batch })
      }
    })
  }

  async getStoreTasks(): Promise<Task[]> {
    return await getOneStorePromise(this.store, select(tasksFeature.selectEntities))
  }

  async renameWorkforceGroup(oldGroup: WorkforceGroup, newGroup: WorkforceGroup) {
    const oldName = oldGroup.name
    const newName = newGroup.name
    const tasks = await this.getStoreTasks()

    const changedTasks = tasks.filter(t => t.groupVisibility && t.groupVisibility.includes(oldName))
    changedTasks.forEach(t => t.groupVisibility.splice(t.groupVisibility.indexOf(oldName), 1, newName))
    changedTasks.forEach(this.updateFullTask.bind(this))
  }

  async deleteWorkforceGroup(oldGroup: WorkforceGroup) {
    const oldName = oldGroup.name
    const tasks = await this.getStoreTasks()

    const changedTasks = tasks.filter(t => t.groupVisibility && t.groupVisibility.includes(oldName))
    changedTasks.forEach(t => t.groupVisibility.splice(t.groupVisibility.indexOf(oldName), 1))
    changedTasks.forEach(this.updateFullTask.bind(this))
  }

  reorderTasks(new_order) {
    this.store.pipe(select(eventPreferenceFeature.selectDocument), take(1)).subscribe((document: EventPreferenceDoc) => {
      if (new_order.length !== document.task_order.length) {
        document.task_order.forEach((t, idx) => {
          if (new_order.indexOf(t) === -1) new_order.splice(idx, 0, t)
        })
        // add to new_order with same index
        document.task_order.sort((a, b) => {
          const ai = new_order.indexOf(a);
          const bi = new_order.indexOf(b);

          if (ai > bi) {
            return 1;
          } else if (ai < bi) {
            return -1;
          }
          return 0;
        })
      } else {
        document.task_order = new_order; // is document
      }
      if (document.createdAt) {
        this.eventService.updateEventPreferences(document, this.eventService.eventId, this.userService.uid, { file: this._file, function: 'reorderTasks()' })
      } else {
        document.createdAt = new Date()
        this.eventService.createEventPreferences(document as EventPreferenceDoc, this.eventService.eventId, this.userService.uid, { file: this._file, function: 'reorderTasks()' })
      }
    })
  }

}
